import { createElement, createContext, useContext, useState } from 'react';
import { ModalA11YProviderProps } from './';

const ModalA11YContext = createContext<(state: boolean) => void>(() => {});

export function useModalA11YContext() {
  return useContext(ModalA11YContext);
}

export function ModalA11YProvider(props: React.PropsWithChildren<ModalA11YProviderProps>) {
  const [descendantModalOpen, setDescendantModalOpen] = useState(false);
  return (
    <ModalA11YContext.Provider value={setDescendantModalOpen}>
      <div aria-hidden={descendantModalOpen} style={{ height: '100%', width: '100%' }}>
        {props.children}
      </div>
    </ModalA11YContext.Provider>
  );
}
